module.exports = __webpack_public_path__ + "img/only-people.2940ef04.svg";